document.documentElement.classList.remove('no-js');

const formatMoney = (cents) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);

const qs = (selector, root = document) => root.querySelector(selector);
const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

function tireMeasures(form) {
  return JSON.parse(form.dataset.tireMeasures || '[]').flatMap((tag) => {
    const match = tag.match(/^Medida:\s*(\d{3})\/(\d{2,3})\s*R(\d{2}(?:[.,]5)?)$/i);
    return match ? [[match[1], match[2], match[3].replace(',', '.')]] : [];
  });
}

function setMeasureOptions(select, values, label) {
  const selected = select.value;
  const options = [...new Set(values)].sort((a, b) => Number(a) - Number(b));
  select.replaceChildren(new Option(label, ''), ...options.map((value) => new Option(value, value)));
  select.value = options.includes(selected) ? selected : '';
  select.disabled = options.length === 0;
}

function updateMeasureSearch(form) {
  const measures = tireMeasures(form);
  const width = qs('[data-tire-width]', form);
  const profile = qs('[data-tire-profile]', form);
  const rim = qs('[data-tire-rim]', form);
  setMeasureOptions(width, measures.map((measure) => measure[0]), 'Largura');
  setMeasureOptions(profile, measures.filter((measure) => measure[0] === width.value).map((measure) => measure[1]), 'Perfil');
  setMeasureOptions(rim, measures.filter((measure) => measure[0] === width.value && measure[1] === profile.value).map((measure) => measure[2]), 'Aro');
  qs('[name="q"]', form).value = width.value && profile.value && rim.value
    ? `"${width.value}/${profile.value} R${rim.value}"` : '';
  qs('[type="submit"]', form).disabled = !qs('[name="q"]', form).value;
  form.hidden = measures.length === 0;
}

qsa('[data-measure-search]').forEach(updateMeasureSearch);
document.addEventListener('shopify:section:load', (event) => {
  qsa('[data-measure-search]', event.target).forEach(updateMeasureSearch);
});

function setDrawer(open) {
  document.body.classList.toggle('drawer-open', open);
  qs('[data-cart-drawer]')?.setAttribute('aria-hidden', open ? 'false' : 'true');
}

async function refreshCart(open = false) {
  const response = await fetch(`${window.Shopify.routes.root}cart.js`);
  const cart = await response.json();
  qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });

  const body = qs('[data-cart-drawer-body]');
  const total = qs('[data-cart-drawer-total]');
  if (total) total.textContent = formatMoney(cart.total_price);
  if (body) {
    body.innerHTML = cart.items.length
      ? cart.items.map((item) => `
          <article class="drawer-line">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title.replaceAll('"', '&quot;')}">` : ''}
            <div>
              <h3>${item.product_title}</h3>
              ${item.variant_title ? `<p>${item.variant_title}</p>` : ''}
              <p>${item.quantity} × ${formatMoney(item.final_price)}</p>
            </div>
          </article>`).join('')
      : '<div class="empty-state"><div><h3>Seu carrinho está vazio</h3><p>Encontre a medida certa para continuar.</p></div></div>';
  }
  if (open) setDrawer(true);
}

document.addEventListener('click', (event) => {
  const menu = event.target.closest('[data-mobile-menu-button]');
  if (menu) {
    const nav = qs('[data-mobile-nav]');
    const open = nav?.classList.toggle('is-open');
    menu.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (event.target.closest('[data-cart-open]')) {
    event.preventDefault();
    refreshCart(true);
  }
  if (event.target.closest('[data-cart-close]')) setDrawer(false);

  const thumb = event.target.closest('[data-product-thumb]');
  if (thumb) {
    const main = qs('[data-product-main-image]');
    if (main) {
      main.src = thumb.dataset.image;
      main.alt = thumb.dataset.alt || '';
    }
  }
});

document.addEventListener('submit', async (event) => {
  const addForm = event.target.closest('[data-ajax-add]');
  if (addForm) {
    event.preventDefault();
    const button = qs('button[type="submit"]', addForm);
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adicionando...'; }
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(addForm),
      });
      if (!response.ok) throw new Error('Não foi possível adicionar o produto.');
      await refreshCart(true);
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  }

  const searchForm = event.target.closest('[data-smart-search]');
  if (searchForm) {
    event.preventDefault();
    const input = qs('input[name="q"]', searchForm);
    const query = input?.value.trim() || '';
    if (!query) return;
    const measurePattern = /(\d{3})\s*[/x-]\s*(\d{2,3})\s*r?\s*(\d{2}(?:[.,]5)?)/i;
    const match = query.match(measurePattern);
    let searchQuery = query;
    if (match) {
      const measure = `${match[1]}/${match[2]} R${match[3].replace(',', '.')}`;
      searchQuery = query.replace(measurePattern, `"${measure}"`);
    }
    window.location.href = `${window.Shopify.routes.root}search?type=product&q=${encodeURIComponent(searchQuery)}`;
  }
});

document.addEventListener('change', (event) => {
  const measureForm = event.target.closest('[data-measure-search]');
  if (measureForm) updateMeasureSearch(measureForm);

  if (event.target.matches('[data-auto-submit]')) event.target.form?.submit();

  const variant = event.target.closest('[data-variant-select]');
  if (variant) {
    const option = variant.selectedOptions[0];
    const form = variant.closest('form');
    const price = qs('[data-product-price]');
    const button = qs('button[type="submit"]', form);
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = option.dataset.available === 'true' ? 'Adicionar ao carrinho' : 'Indisponível';
    }
  }
});
